export default "__VITE_ASSET__1791afc3__"